import React, {useEffect, useState} from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import instance from "../../services/services";
import { BRAND_DETAIL_URL } from "../../utils/urls";
import DefaultSelect from "../More/DefaultSelect";
import ProductSection from "../../components/Product/ProductSection";
import PaginationSection from "../../components/Product/Pagination";
import useUserStore from "../../store/userStore";
import { useLanguage } from "../../hooks/useLanguage";
import { formatUrl } from "../../utils/validation";

function BrandPage(){
  const { t } = useLanguage();
  const userInfo = useUserStore((state) => state.userInfo);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const brandCode = searchParams.get('title');
  const brandSeq = searchParams.get('brand_seq');
  const brandUrl = searchParams.get('brand_url');
  const [brandDetail, setBrandDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 30;
  const [currentSort, setCurrentSort] = useState("regist_date");
  const [categories, setCategories] = useState([]);
  const [brandInfo, setBrandInfo] = useState([]);

  useEffect(()=> {
    const getBrandDetail = async () => {
      try {
        setLoading(true);
        const response = await instance.post(BRAND_DETAIL_URL, {
          brand_code: brandCode,
          member_seq: userInfo.member_seq ? userInfo.member_seq : '',
          searchSort: currentSort,
          offset: currentPage,
          newpage_check: "",
          brand_seq: brandSeq
        });
        setBrandInfo(response.data.data.categoryInfo);
        setCategories(response.data.data.categoryList);
        setBrandDetail(response.data.data.data || []);
        setTotalCount(parseInt(response.data.data.cntRow || 0));
        setLoading(false);
      } catch (error) {
        console.error("브랜드 상세 조회 오류:", error);
        setLoading(false);
      }
    };
    getBrandDetail();
  }, [brandCode, userInfo.member_seq, currentPage, currentSort, brandSeq]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  const handleSortChange = (value) => {
    setCurrentSort(value);
    setCurrentPage(1);
  };

  const BeforeContent = () => (
    <div className="auth_find" style={{marginBottom:"-16px"}}>
        <div className="product_total">
            {t('product_total_count', {count: totalCount})}
        </div>
        <DefaultSelect 
            defaultValue={currentSort}
            onChange={handleSortChange}
        />
    </div>
  );

  const AfterContent = () => (
    <div className="pagination_wrap">
        <PaginationSection
            totalCount={totalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onArrow={handleArrowClick}
        />
    </div>
  );

  const renderCategoryTabs = () => {
    if (!categories || categories.length === 0) {
      return null; // 또는 <div>카테고리가 없습니다</div>
    }
    
    return (
      <div className="btn_group flex-justify-center flex-wrap">
          {categories.map((category) => (
              <button 
                  key={category.category_code}
                  className="tap_btn" 
                  type="button"
                  onClick={() => {
                      // URL 파라미터로 전달
                      const params = new URLSearchParams({
                          brand_code: brandCode,
                          category_code: category.category_code,
                          member_seq: userInfo.member_seq || "",
                          category_name: category.category_name,
                          currentSort: currentSort,
                          currentPage: currentPage.toString(),
                          brand_seq: brandSeq || ""
                      });
                      
                      navigate(`/category/brandPage/brandPageSec?${params.toString()}`);
                  }}
              >
                  {category.category_name}
              </button>
          ))}
      </div>
    );
  };

  const handleBreadcrumbClick = (level) => {
    switch(level) {
      case 'home':
        navigate('/');
        break;
      default:
        // 기본 동작 (아무것도 하지 않음)
        break;
    }
  };
  return(
    <div>
      <section className="prod_section">
        <div 
          className="product_banner cate_brand"
          style={{backgroundImage:`url(${window.innerWidth > 768 ? brandInfo?.pc_img_url : brandInfo?.mobile_img_url})`}}
        >
          <div className="inner">
            <ul className="bread_crumb">
              <li className="group_item">
                <p style={{cursor: 'pointer'}} onClick={() => handleBreadcrumbClick('home')}>HOME</p>
              </li>
              <li className="group_item">
                <p>BRAND</p>
              </li>
              <li className="group_item active">
                <p>{brandCode}</p>
              </li>
            </ul>
            
            <div className="product_tit">
              <h4 className="tit">BRAND</h4>
              <p className="sub">{brandInfo?.cate_comment}</p>
            </div>
          </div>
        </div>

        <div className="inner main_prod_list cate_container">

          {/* 상단 */}
          <div className="brand_top_tab">
            <div className="brand_section_title"
                  onClick={() => window.open(formatUrl(brandUrl), '_blank')}
                  style={{cursor: 'pointer'}}
            >
                {brandCode} 
            </div>
            {/* 동적으로 생성된 카테고리 탭 */}
            {renderCategoryTabs()}
          </div>
          
          <div className="p0">
            {loading ? (
              <div className="loading-overlay">
                <div className="loading">로딩 중...</div>
              </div>
            ) : brandDetail.length > 0 ? (
              <ProductSection
                products={brandDetail}
                showTabs={false}
                showMoreButton={false}
                beforeContent={<BeforeContent />}
                afterContent={<AfterContent />}
                useSwiper={false}
              />
            ) : (
              <div className="no_result">
                <p>{t('no_product_found')}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  )
};

export default BrandPage;